













import { Component, Prop, Vue } from 'vue-property-decorator';
import { IAlert } from '@lib-shared/alert/types/alert';

@Component
export default class Alert extends Vue {
  @Prop() alert: IAlert;
  @Prop({ default: true }) visible?: boolean;
  isVisible = true;
  closeTimeout = 1000;

  hide() {
    this.isVisible = false;
    this.close();
  }

  close() {
    setTimeout(() => {
      this.$emit('close');
    }, this.closeTimeout);
  }

  created() {
    setTimeout(() => {
      this.isVisible = false;
      this.close();
    }, this.alert.timeout);
  }
}
